import React from "react";

export default function ProfileStudent() {
  return <div>ProfileStudent</div>;
}
